const validate = (value: string) => {

    const re = /^\d{8}$/

    return re.test(value)
}

export { validate }

export default {
    validate
}